var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/es6.parse-int.js
// module id = 434
// module chunks = 88 89